import React from 'react';
import { DollarSign, ChevronRight, BarChart3, Receipt, ShoppingBag } from 'lucide-react';

const FinancialManagement = ({ onNavigate, permissions }) => {
    // Check if user has permission to view this section
    // Typically allowed for Treasurers, Admins, and Auditors (read-only for auditors handled by buttons)
    if (!permissions.canViewFinancials) return null;

    return (
        <div>
            <h3 className="text-lg font-bold text-gray-900 mb-3">💰 Financial Management</h3>
            <div className="grid grid-cols-2 gap-4">
                {/* Hidden per user request 
                <button
                    onClick={() => onNavigate('financial-dashboard')}
                    className="bg-gradient-to-r from-emerald-500 to-teal-600 rounded-xl shadow-sm p-6 hover:shadow-md text-left transition-shadow text-white"
                >
                    <div className="flex items-center justify-between mb-2">
                        <DollarSign className="text-white" size={24} />
                        <ChevronRight className="text-white" size={20} />
                    </div>
                    <h3 className="font-bold text-lg">Financial Dashboard</h3>
                    <p className="text-sm opacity-90">Received, expenses & receivables</p>
                </button>

                <button
                    onClick={() => onNavigate('financial-reports')}
                    className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl shadow-sm p-6 hover:shadow-md text-left transition-shadow text-white"
                >
                    <div className="flex items-center justify-between mb-2">
                        <BarChart3 className="text-white" size={24} />
                        <ChevronRight className="text-white" size={20} />
                    </div>
                    <h3 className="font-bold text-lg">Financial Reports</h3>
                    <p className="text-sm opacity-90">Complete financial transparency</p>
                </button>
                */}

                {permissions.canManageFinancials && (
                    <button
                        onClick={() => onNavigate('financial-reports-hub')}
                        className="group flex items-center gap-4 bg-gradient-to-r from-violet-50 to-indigo-50 hover:from-violet-100 hover:to-indigo-100 rounded-xl p-4 transition-all text-left border border-violet-100"
                    >
                        <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                            <BarChart3 className="text-violet-600" size={20} />
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="font-bold text-gray-900 truncate">Reports</h3>
                            <p className="text-xs text-gray-500 truncate">Financial documents</p>
                        </div>
                        <ChevronRight className="text-violet-300 group-hover:text-violet-600 transition-colors shrink-0" size={18} />
                    </button>
                )}

                {permissions.canManageFinancials && (
                    <button
                        onClick={() => onNavigate('payment-management')}
                        className="group flex items-center gap-4 bg-gradient-to-r from-emerald-50 to-green-50 hover:from-emerald-100 hover:to-green-100 rounded-xl p-4 transition-all text-left border border-emerald-100"
                    >
                        <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                            <DollarSign className="text-emerald-600" size={20} />
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="font-bold text-gray-900 truncate">Manage Payments</h3>
                            <p className="text-xs text-gray-500 truncate">Track payments</p>
                        </div>
                        <ChevronRight className="text-emerald-300 group-hover:text-emerald-600 transition-colors shrink-0" size={18} />
                    </button>
                )}

                {permissions.canManageFinancials && (
                    <button
                        onClick={() => onNavigate('manage-expenses')}
                        className="group flex items-center gap-4 bg-gradient-to-r from-orange-50 to-amber-50 hover:from-orange-100 hover:to-amber-100 rounded-xl p-4 transition-all text-left border border-orange-100"
                    >
                        <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                            <Receipt className="text-orange-600" size={20} />
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="font-bold text-gray-900 truncate">Expenses</h3>
                            <p className="text-xs text-gray-500 truncate">Approve expenses</p>
                        </div>
                        <ChevronRight className="text-orange-300 group-hover:text-orange-600 transition-colors shrink-0" size={18} />
                    </button>
                )}

                {permissions.canManageFinancials && (
                    <button
                        onClick={() => onNavigate('custom-merch-orders')}
                        className="group flex items-center gap-4 bg-gradient-to-r from-rose-50 to-pink-50 hover:from-rose-100 hover:to-pink-100 rounded-xl p-4 transition-all text-left border border-rose-100"
                    >
                        <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                            <ShoppingBag className="text-rose-600" size={20} />
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="font-bold text-gray-900 truncate">Merch Orders</h3>
                            <p className="text-xs text-gray-500 truncate">Track orders</p>
                        </div>
                        <ChevronRight className="text-rose-300 group-hover:text-rose-600 transition-colors shrink-0" size={18} />
                    </button>
                )}

                {/* Hidden per user request
                {permissions.canManageFinancials && (
                    <button
                        onClick={() => onNavigate('registration-fee-validation')}
                        className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl shadow-sm p-6 hover:shadow-md text-left transition-shadow text-white"
                    >
                        <div className="flex items-center justify-between mb-2">
                            <DollarSign className="text-white" size={24} />
                            <ChevronRight className="text-white" size={20} />
                        </div>
                        <h3 className="font-bold text-lg">Initial Donation Validation</h3>
                        <p className="text-sm opacity-90">Ensure correct initial donations</p>
                    </button>
                )}
                */}




            </div>
        </div>
    );
};

export default FinancialManagement;
